import React from "react";

import Alert from "../../../../../components/Alert";
import Container from "../../../../../components/Container";
import Spacer from "../../../../../components/Spacer";
import Text from "../../../../../components/Text";

import css from "../../ViewFieldHistory.module.scss";

type FieldHistoryItemErrorFallbackProps = {
	fieldName?: string;
};

const FieldHistoryItemErrorFallback = ({ fieldName }: FieldHistoryItemErrorFallbackProps) => {
	return (
		<Container column className={css.FieldHistoryItem}>
			<Container gap="4px">
				<Text size="paragraph-3" weight="semi-bold">
					History Item Error
				</Text>
			</Container>
			<Spacer height={2} />
			<Alert
				type="error"
				message={`This history item for ${fieldName || "this field"} contains data in an incorrect format and cannot be displayed. The data may be corrupted or in an unexpected format.`}
			/>
			<Spacer height={3} />
		</Container>
	);
};

export default FieldHistoryItemErrorFallback;
